import { queryKeys } from '@api/queryKeys'
import { getIsCostEnabled } from '@data/costDataProvider'
import { useQuery } from '@tanstack/react-query' // TODO> Use this hook everywhere where we need to check if cost is enabled

// TODO> Use this hook everywhere where we need to check if cost is enabled
export const useIsCostEnabled = ({ companyId }: { companyId?: number }) => {
  const queryKey = queryKeys.isCostEnabled.toKeyWithArgs(companyId?.toString())

  return useQuery<boolean>({
    queryKey,
    enabled: !!companyId,
    staleTime: Number.POSITIVE_INFINITY,
    gcTime: Number.POSITIVE_INFINITY,
    queryFn: async () => {
      return await getIsCostEnabled(companyId)
    },
  })
}
